import type { ApiResponse } from '../api/apiService';

export type LoginTranslation = (key: string, defaultValue?: string) => string;

export function getLoginErrorMessage(
  response: ApiResponse<unknown> | undefined,
  t: LoginTranslation,
): string {
  const errorData = response?.data as any;

  if (!response || response.status === 0) {
    return t('networkError');
  }

  if (response.status >= 500) {
    return errorData?.detail || t('serverUnavailable');
  }

  if (errorData?.email?.[0]) {
    return errorData.email[0];
  }

  if (errorData?.password?.[0]) {
    return errorData.password[0];
  }

  if (errorData?.non_field_errors?.[0]) {
    return errorData.non_field_errors[0];
  }

  return t('invalidCredentials');
}
